import { axiosInstance } from '@/plugins/axios';

// 门店接口相关
const aciton = {
  list: ['candao.storeStandard.getStoreList', 'candao.storeStandard.getNearStoreList', 'candao.storeOwn.listWhiteListAddress'], // 获取门店列表/附近的门店列表/联想白名单地址
  near: 'candao.storeStandard.getNearStore', // 获取附近门店
  info: 'candao.storeStandard.getStore', // 获取门店信息
  range: 'candao.storeStandard.getStoreDeliveryRange', // 根据门店id和用户地址坐标获取配送范围
};

const store = {
  near: ({ actionName = aciton.near, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getNearStore',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  range: ({ actionName = aciton.range, ...data }) => axiosInstance({ // 根据门店id和用户地址坐标获取配送范围
    method: 'post',
    url: 'Action',
    params: {
      method: 'getStoreDeliveryRange',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  info: ({ actionName = aciton.info, ...data }) => axiosInstance({ // 获取门店信息
    method: 'post',
    url: 'Action',
    params: {
      method: 'getStore',
    },
    data: {
      actionName,
      ...data,
    },
  }),
};

store.list = {
  store: ({ actionName = aciton.list[0], ...data }) => axiosInstance({ // 获取门店列表
    method: 'post',
    url: 'Action',
    params: {
      method: 'getStoreList',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  white: ({ actionName = aciton.list[2], ...data }) => axiosInstance({ // 联想白名单地址
    method: 'post',
    url: 'Action',
    params: {
      method: 'listWhiteListAddress',
    },
    data: {
      actionName,
      ...data,
    },
  }),
};

export default store;
